import type { NotificationPort, SyncPort } from '../application/contracts';

export const requestPersistentStorage = async (): Promise<
  'granted' | 'denied' | 'unsupported'
> => {
  if (navigator.storage?.persist == null) {
    return 'unsupported';
  }
  return (await navigator.storage.persist()) ? 'granted' : 'denied';
};

export const getStorageEstimate = async (): Promise<{
  usage: number | null;
  quota: number | null;
}> => {
  if (navigator.storage?.estimate == null) {
    return { usage: null, quota: null };
  }
  const estimate = await navigator.storage.estimate();
  return {
    usage: estimate.usage ?? null,
    quota: estimate.quota ?? null,
  };
};

export class LocalOnlySyncAdapter implements SyncPort {
  readonly available = false;
  readonly label = 'Partage non disponible dans cette version locale';

  getStatus(): Promise<'unavailable'> {
    return Promise.resolve('unavailable');
  }
}

export class BrowserNotificationAdapter implements NotificationPort {
  readonly available = 'Notification' in globalThis;

  getPermission(): NotificationPermission | 'unsupported' {
    return this.available ? Notification.permission : 'unsupported';
  }

  async requestPermission(): Promise<NotificationPermission | 'unsupported'> {
    return this.available ? Notification.requestPermission() : 'unsupported';
  }

  async show(title: string, options: NotificationOptions): Promise<boolean> {
    if (!this.available || Notification.permission !== 'granted') return false;
    if ('serviceWorker' in navigator) {
      const registration = await navigator.serviceWorker.getRegistration();
      if (registration != null) {
        await registration.showNotification(title, options);
        return true;
      }
    }
    new Notification(title, options);
    return true;
  }
}
